var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeapLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 50,
    viewBox: "0 0 188 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10415_2574)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18474 9.33887L1.82128 14.4575V47.7251H3.30103L0.916992 50.0003H6.10607L15.8739 40.6783H10.6873L13.0688 38.4031H12.9692V9.33887H7.18474Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5909 47.7253L32.4472 44.0474V38.4033H18.2551L8.4873 47.7253H28.5909Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.26855V13.3896L5.36346 8.26855H0Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2295 47.9838V38.8235H54.3572V32.6612H73.9003V24.169H60.458L69.2294 15.798H78.5413V6.6377L75.9356 9.12212H43.2441V41.3745L50.1671 47.9814H76.227L76.2295 47.9838ZM54.3572 18.2824H66.0532L59.8875 24.1666H54.3572V18.2824Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.181 31.7916H125.938L115.891 9.1084H105.147L91.5601 39.7798V47.768H99.6787L105.951 32.6879H105.892L110.433 21.7754L110.463 21.8467L110.493 21.7754L114.606 31.7916H120.849L124.58 40.8782H118.337L121.167 47.768H130.009V40.9828L129.961 40.8782H136.207L132.181 31.7916Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10415_2574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 188,
    height: 50
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188 0H0V50H188V0Z",
    fill: "currentColor"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.917 28.4694C181.443 27.4233 181.787 26.2632 181.994 25.015H185.683C185.815 24.2114 185.9 23.3793 185.9 22.4925V22.3832C185.9 21.6414 185.833 20.9353 185.738 20.2458H182.048C181.869 18.9692 181.543 17.7733 181.032 16.6821C180.247 15.0012 179.126 13.5842 177.672 12.4312C176.214 11.2805 174.453 10.4032 172.385 9.79936C170.318 9.19549 168.018 8.89355 165.49 8.89355H155.057L148.251 15.3887V20.2458H151.94V25.015H148.251V47.2797H152.503L159.399 40.699V36.3126H164.914C167.403 36.3126 169.712 36.0202 171.837 35.4353C173.962 34.8505 175.793 33.9732 177.325 32.8035C178.857 31.6338 180.056 30.1907 180.917 28.4718M170.646 25.0174C170.362 25.6355 169.939 26.1728 169.369 26.6293C168.238 27.5303 166.678 27.9797 164.685 27.9797H159.399V25.0174H163.088V20.2482H159.399V17.7804H164.628C166.658 17.7804 168.238 18.2108 169.369 19.0761C169.797 19.4042 170.118 19.806 170.385 20.2482H174.074C174.51 20.971 174.754 21.8268 174.754 22.8515V22.9609C174.754 23.724 174.615 24.4111 174.336 25.0174H170.646Z",
    fill: "currentColor",
    opacity: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10415_2574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 50,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeapLogo);
export default __webpack_public_path__ + "static/media/leap_logo.52adf68e7995f64dbe2a816460c1c122.svg";
export { ForwardRef as ReactComponent };